var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"home-new-section key-fund"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"layout"},[_c('div',{staticClass:"section-inner"},[_c('new-scheme-information',{attrs:{"asComponent":true}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }